import { Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  ACCOUNT,
  DEFAULT_AUTOPAY_PAPERLESS_DISCOUNT_MESSAGES,
} from "../../../../Constants/constants";
import { getBannerMessageByKey } from "../../../../Services/helper";
import { CenterStack, CustomChip, MiniCard } from "../../../../Styles/GlobalStyles";
import { Theme } from "../../../../Styles/GlobalTheme";
import Button from "../../../Button/Button";

export const AutoPay = (props: any) => {
  const navigate = useNavigate();
  const { type, billingError } = props;
  const { autoPayData } = useSelector((state: any) => state?.autopayPaperlessDetails);
  const { autopayAmount, isNewCustomer, isSMB, showAutopayDiscountMessage } = useSelector(
    (state: any) => state.customerPlanDetails
  );
  const isAdmin = process.env.REACT_APP_CXP_ADMIN_ACCESS_ENABLED;
  const sideCoreBannerMessages = useSelector(
    (state: any) => state?.sideCoreContent?.bannerMessages
  );
  const sidecoreDiscountMessages = getBannerMessageByKey(
    "autopay-paperless-discount-messages",
    sideCoreBannerMessages,
    false
  );
  const autopayPaperlessDiscountMessages = Object.fromEntries(
    Object.keys(DEFAULT_AUTOPAY_PAPERLESS_DISCOUNT_MESSAGES).map((key) => [
      key,
      sidecoreDiscountMessages?.[key] || DEFAULT_AUTOPAY_PAPERLESS_DISCOUNT_MESSAGES[key],
    ])
  );
  const handleManage = () => {
    if (type === ACCOUNT) {
      navigate("/account/manageautopay");
    } else {
      navigate("/billing/manageautopay");
    }
  };
  const handleSignUp = () => {
    if (type === ACCOUNT) {
      navigate("/account/signupautopay", { state: { ACCOUNT } });
    } else {
      navigate("/billing/signupautopay");
    }
  };

  return (
    <>
      <MiniCard sx={{ display: "flex", flexDirection: "column", position: "relative" }}>
        <Stack
          visibility={
            autoPayData &&
            Object.keys(autoPayData)?.length === 0 &&
            !billingError &&
            autopayAmount &&
            !isNewCustomer &&
            !isSMB &&
            showAutopayDiscountMessage
              ? "visible"
              : "hidden"
          }
          direction={"row"}
          justifyContent={"center"}
          sx={{ position: "absolute", right: 8, top: 8 }}>
          <CustomChip
            label={autopayPaperlessDiscountMessages["autopay-discount-chip-label"]}
            color="success"
            variant="outlined"
          />
        </Stack>
        <CenterStack spacing={1} flex={1}>
          {isNewCustomer ? (
            <>
              <Typography textAlign="center" component="p">
                Autopay
              </Typography>
              <Typography
                component="p"
                textAlign="center"
                color={Theme.palette.customcolor.profileTypoGraphyColor}>
                Autopay will be available once your first bill is generated.
              </Typography>
            </>
          ) : autoPayData && Object.keys(autoPayData)?.length > 0 ? (
            <>
              <Typography textAlign="center" component="p">
                Autopay enabled
              </Typography>
              <Button
                onClick={handleManage}
                disabled={isAdmin === "TRUE"}
                title="Manage autopay"
                type="pay"
              />
            </>
          ) : (
            <>
              <Typography textAlign="center" component="p">
                Autopay disabled
              </Typography>
              <Button
                onClick={handleSignUp}
                disabled={isAdmin === "TRUE"}
                title="SET UP AUTOPAY"
                type="pay"
              />
            </>
          )}
        </CenterStack>
      </MiniCard>
    </>
  );
};
